import apiClient, { USE_MOCK } from '@shared/api/client';
import { ENDPOINTS } from '@shared/api/endpoints';
import { mockHomeData } from './mockHomeData';

/**
 * 首頁 API Service
 * 根據 USE_MOCK 設定決定使用真實 API 或 Mock 資料
 */

/**
 * 模擬網路延遲
 */
const delay = (ms = 500) => new Promise(resolve => setTimeout(resolve, ms));

/**
 * 取得首頁輪播圖資料
 */
export const getSlides = async () => {
  if (USE_MOCK) {
    await delay(300);
    return {
      success: true,
      data: mockHomeData.slides,
    };
  }

  return apiClient.get(ENDPOINTS.HOME.SLIDES);
};

/**
 * 取得首頁新聞列表
 * @param {number} limit - 限制數量
 */
export const getNews = async (limit = 4) => {
  if (USE_MOCK) {
    await delay(300);
    return {
      success: true,
      data: mockHomeData.news.slice(0, limit),
    };
  }

  return apiClient.get(ENDPOINTS.HOME.NEWS, { params: { limit } });
};

/**
 * 取得首頁影片列表
 * @param {number} limit - 限制數量
 */
export const getVideos = async (limit = 3) => {
  if (USE_MOCK) {
    await delay(400);
    return {
      success: true,
      data: mockHomeData.videos.slice(0, limit),
    };
  }

  return apiClient.get(ENDPOINTS.HOME.VIDEOS, { params: { limit } });
};

/**
 * 取得互動專區項目
 */
export const getInteractiveItems = async () => {
  if (USE_MOCK) {
    await delay(200);
    return {
      success: true,
      data: mockHomeData.interactiveItems,
    };
  }

  return apiClient.get(ENDPOINTS.HOME.INTERACTIVE);
};

/**
 * 取得首頁所有資料（一次性載入）
 */
export const getHomeData = async () => {
  if (USE_MOCK) {
    await delay(500);
    return {
      success: true,
      data: {
        slides: mockHomeData.slides,
        news: mockHomeData.news,
        videos: mockHomeData.videos,
        interactiveItems: mockHomeData.interactiveItems,
      },
    };
  }

  // 真實 API 可能有專門的端點一次返回所有首頁資料
  return apiClient.get(ENDPOINTS.HOME.ALL);
};

/**
 * 取得最新消息或最新影音列表
 * @param {number} sectionId - 1: 最新消息, 2: 最新影音
 */
export const getLatestNews = async (sectionId) => {
  return apiClient.post(ENDPOINTS.LATEST_NEWS.LIST, { section_id: sectionId });
};

/**
 * 取得最新消息詳情
 * @param {number} postId
 */
export const getLatestNewsDetail = async (postId) => {
  return apiClient.post(ENDPOINTS.LATEST_NEWS.DETAIL, { post_id: postId });
};

export default {
  getSlides,
  getNews,
  getVideos,
  getInteractiveItems,
  getHomeData,
  getLatestNews,
  getLatestNewsDetail,
};
